// Validación pura de coordenadas GPS (sin React): fuente única de verdad
// para los mapas del frontend (picker, pagos, botón "Ver en mapa"). El
// backend serializa los numeric de Postgres como string (igual que `valor`),
// por eso se aceptan number y string numérico.
export interface RangoCoordenada {
  min: number;
  max: number;
}

export const RANGO_LATITUD: RangoCoordenada = { min: -90, max: 90 };
export const RANGO_LONGITUD: RangoCoordenada = { min: -180, max: 180 };

/**
 * Coordenada GPS válida: número finito distinto de cero (0,0 es el valor de
 * "sin GPS" en el sistema legacy) y, si se pasa un rango, dentro del mismo.
 */
export function esCoordenadaValida(v: unknown, rango?: RangoCoordenada): v is number {
  let n: number;
  if (typeof v === 'string') {
    if (v.trim() === '') return false;
    n = Number(v);
  } else if (typeof v === 'number') {
    n = v;
  } else {
    return false;
  }
  if (!Number.isFinite(n) || n === 0) return false;
  return rango ? n >= rango.min && n <= rango.max : true;
}

/** Par lat/lng válidos juntos (ambos finitos y en rango) o null. */
export function coordenadasValidas(
  lat: unknown,
  lng: unknown,
): { lat: number; lng: number } | null {
  if (!esCoordenadaValida(lat, RANGO_LATITUD) || !esCoordenadaValida(lng, RANGO_LONGITUD)) {
    return null;
  }
  // El guard de tipo estrecha a number pero el valor puede seguir siendo
  // string (los pagos serializan lat/long como string): normalizar aquí.
  return { lat: Number(lat), lng: Number(lng) };
}
